export type Permission =
  | "history.write"
  | "stock.write"
  | "share.manage"
  | "accounts.manage"
  | "integration.sync"
  | "irrigation.control"
  | "integration.settings"
  | "zone.write"
  | "zone.photo.write"
  | "recipe.edit"
  | "recipe.publish"
  | "nutrition.season.manage";

export type User = {
  id: number;
  email: string;
  name: string;
  role: "owner" | "gardener";
  permissions: Permission[];
};

export class ApiError extends Error {
  status: number;
  retryAfter: number | null;

  constructor(message: string, status: number, retryAfter: number | null = null) {
    super(message);
    this.status = status;
    this.retryAfter = retryAfter;
  }
}

function cookie(name: string): string | null {
  const value = document.cookie
    .split("; ")
    .find((item) => item.startsWith(`${name}=`))
    ?.split("=")
    .slice(1)
    .join("=");
  return value ? decodeURIComponent(value) : null;
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = (init.method ?? "GET").toUpperCase();
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData) && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  if (!["GET", "HEAD", "OPTIONS"].includes(method)) {
    const csrf = cookie("gazon_csrf");
    if (csrf) headers.set("X-CSRF-Token", csrf);
  }
  let response: Response;
  try {
    response = await fetch(path, { ...init, headers, credentials: "same-origin" });
  } catch {
    throw new ApiError("Нет связи с сервером. Данные не сохранены.", 0);
  }
  if (!response.ok) {
    let message = "Не удалось выполнить запрос";
    try {
      const payload = await response.json();
      message = typeof payload.detail === "string"
        ? payload.detail
        : typeof payload.detail?.message === "string"
          ? payload.detail.message
          : message;
    } catch {
      // Keep the safe fallback message.
    }
    throw new ApiError(message, response.status, Number(response.headers.get("Retry-After")) || null);
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}

export async function bootstrap(): Promise<void> {
  await api<{ csrf_token: string }>("/api/auth/bootstrap");
}
